const companySettings: any = {
	administrators: [
		{
			id: 1,
			name: 'Admin 1',
			role: 'Managing partner',
		},
		{
			id: 2,
			name: 'Admin 2',
			role: 'Managing partner',
		},
		{
			id: 3,
			name: 'Admin 3',
			role: 'Managing partner',
		},
		{
			id: 4,
			name: 'Admin 4',
			role: 'Managing partner',
		},
		{
			id: 5,
			name: 'Admin 5',
			role: 'Managing partner',
		}, {
			id: 6,
			name: 'Admin 6',
			role: 'Managing partner',
		},
	],
	contentManagers: [
		{
			id: 1,
			name: 'Manager 1',
			role: 'Managing partner',
		},
		{
			id: 2,
			name: 'Manager 2',
			role: 'Managing partner',
		},
		{
			id: 3,
			name: 'Manager 3',
			role: 'Managing partner',
		},
		{
			id: 4,
			name: 'Manager 4',
			role: 'Managing partner',
		},
	],
	users: [
		{
			id: 1,
			name: 'User 1',
			role: 'Managing partner',
		},
		{
			id: 2,
			name: 'User 2',
			role: 'Managing partner',
		},
		{
			id: 3,
			name: 'User 3',
			role: 'Managing partner',
		},
	],
	notifications: [
		{
			id: 1,
			name: 'Notification 1',
			checked: true,
		},
		{
			id: 2,
			name: 'Notification 2',
			checked: false,
		},
		{
			id: 3,
			name: 'Notification 3',
			checked: false,
		},
		{
			id: 4,
			name: 'Notification 4',
			checked: true,
		},
		{
			id: 5,
			name: 'Notification 5',
			checked: true,
		},


	],

}
export default companySettings